module.exports = __webpack_public_path__ + "images/232579f40ed97473b0ea5d1cfa4e4c77.svg";